import { makeStyles } from '@material-ui/core/styles';
import {
    PRIMARY_DARK, TEXT_COLOR,
} from '@theme_color';

const useStyles = makeStyles((theme) => ({
    dialogContainerRoot: {
        overflowX: 'hidden',
        '& .MuiDialog-paperScrollPaper': {
            '&::-webkit-overflow-scrolling': 'touch',
            '&::-webkit-scrollbar': {
                height: '.5em',
                width: '.5em',
            },
            '&::-webkit-scrollbar-track': {
                '-webkit-box-shadow': 'inset 0 0 2px rgba(0,0,0,0.00)',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: TEXT_COLOR,
                borderRadius: 5,
            },
        },
    },
    dialogContainer: {
        borderRadius: 8,
        padding: 30,
        position: 'relative',
        overflowX: 'hidden',
        [theme.breakpoints.down('sm')]: {
            padding: '30px 10px',
        },
    },
    titleSection: {
        padding: 0,
        paddingBottom: 16,
        color: PRIMARY_DARK,
        border: 0,
    },
    header: {
        fontSize: 20,
        fontWeight: 'bold',
    },
    contentSection: {
        color: PRIMARY_DARK,
        fontSize: 14,
        padding: 0,
        paddingBottom: 30,
        overflowY: 'visible',
        overflowX: 'hidden',
    },
    dialogActions: {
        gap: 16,
        '&.center': {
            justifyContent: 'center',
        },
        '&.right': {
            justifyContent: 'right',
        },
        '&.left': {
            justifyContent: 'left',
        },
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    closeButton: {
        position: 'absolute',
        padding: 0,
        right: 20,
        top: 20,
        color: PRIMARY_DARK,
    },
}));

export default useStyles;
